import React from 'react';
import { FallbackProps } from 'react-error-boundary';

export const AnalyticsErrorFallback: React.FC<FallbackProps> = ({ error, resetErrorBoundary }) => {
  return (
    <div className="rounded-md border bg-card p-6 text-card-foreground shadow-sm">
      <h2 className="text-lg font-semibold">Something went wrong</h2>
      <p className="text-muted-foreground mt-2">{error?.message || 'An unexpected error occurred.'}</p>
      <button
        onClick={resetErrorBoundary}
        className="mt-4 inline-flex items-center rounded-md border px-3 py-2 text-sm font-medium transition-colors hover:bg-muted"
        aria-label="Retry loading analytics section"
      >
        Retry
      </button>
    </div>
  );
};
